import { RADIOV_ICON } from '../../assets/icons';

interface RadioButtonProps {
  checked: boolean;
  onChange: (value: boolean) => void;
  name: string;
  label: string;
  disabled?: boolean;
}

export function RadioButton({ checked, label, name, onChange, disabled }: RadioButtonProps) {
  return (
    <div className="flex gap-4 items-center">
      <div className={`w-6 h-6 shrink-0 relative text-sm rounded-md cursor-pointer`}>
        <input
          type="radio"
          checked={checked}
          name={name}
          disabled={disabled}
          onChange={(e) => {
            onChange(e.target.value === 'on' ? true : false);
          }}
          className={`absolute top-0 left-0 z-20 w-full h-full appearance-none cursor-pointer`}
        />
        <div
          className={`absolute top-0 left-0 w-full h-full rounded-full border transition-all flex items-center justify-center 
       ${checked ? 'border-primary bg-neutralBlue1' : 'border-neutralGray3 bg-white'} ${
            disabled && 'bg-neutralGray3 border-neutralGray3'
          } `}
        >
          {checked && <img src={RADIOV_ICON} className="" />}
        </div>
      </div>
      <label htmlFor={label} className="text-sm">
        {label}
      </label>
    </div>
  );
}
